import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-codeing',
  standalone: false,
  templateUrl: './codeing.component.html',
  styleUrls: ['./codeing.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CodeingComponent { }
